import { gql } from 'graphql-tag';

export const PARTICIPANT_DATA = gql`
  query participantData($id: Int!) {
    participant(id: $id) {
      id
      firstName
      lastName
      fullName
      birthdate
      gender
      street
      city
      state
      zipcode
      classroomOrTeacher
      tshirtSize
    }
  }
`;

export const participantEntityCategoriesQuery = gql`
  query participantEntityCategoriesQuery {
    participantEntityCategories {
      id
      categoryId
      category {
        id
        name
        abbreviation
        type
        categoryOptions {
          id
          isDefault
          name
          abbreviation
          shortDescription
          longDescription
        }
      }
      fieldType
      parentEntityCategoryId
      franchiseId
      franchisorId
      isMultiSelect
      isRequired
      isEditable
    }
  }
`;
